import {WAR_PHASE_STAGES} from "../../../constants/phases";
import {
  selectCurrentPlayer,
  selectPhase,
  selectRound,
  selectWarPhaseStage
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {selectUnitAutoSelectionState} from "../../../redux/reducers/privateStateReducer/selectors";
import {
  checkIfUnitAbilityProcessed,
  checkIfUnitManeuverProcessed,
  checkIfUnitMovementProcessed,
  checkIfUnitShootingProcessed
} from "./checkIfUnitProcessed";

const NO_SKIPS = Object.freeze([]);

// Ключ пропусков хода: раунд, фаза, этап войны и игрок. Пропуски одного этапа
// одного игрока не переносятся ни на следующий этап, ни на другого игрока в
// hot-seat, ни на тот же этап следующего раунда
export const getUnitTurnSkipKey = (state, playerId) => (
  `${selectRound(state)}|${selectPhase(state)}|${selectWarPhaseStage(state)}|${playerId}`
);

/**
 * Отряды, пропустившие ход на текущем этапе войны у игрока (spec
 * unit-auto-selection, «Пропуск хода отрядом»). Пропуски живут только у
 * клиента (privateStateReducer/unitAutoSelectionReducer): у соперника и на
 * сервере список пуст. Пока ключ совпадает с текущим этапом, возвращается один
 * и тот же массив — по его ссылке мемоизирован подсчет дел
 */
export const selectSkippedUnitIds = (state, playerId) => {
  const {skipKey, skippedUnitIds} = selectUnitAutoSelectionState(state);
  return skipKey && skipKey === getUnitTurnSkipKey(state, playerId) ? skippedUnitIds : NO_SKIPS;
};

const PROCESSED_BY_ACTION = {
  [WAR_PHASE_STAGES.MOVEMENT]: checkIfUnitMovementProcessed,
  [WAR_PHASE_STAGES.ABILITIES]: checkIfUnitAbilityProcessed,
  [WAR_PHASE_STAGES.SHOOTING]: checkIfUnitShootingProcessed,
  [WAR_PHASE_STAGES.MANEUVER]: checkIfUnitManeuverProcessed,
};

/**
 * Рисовать ли на отряде отметку пропуска хода — приглушенный силуэт и «zZ»
 * (spec unit-auto-selection, «Значок пропуска на поле»): свой отряд текущего
 * игрока пропустил ход на этом этапе и с тех пор не действовал. Пропуски у
 * соперника и зрителя пусты — у них отметки нет
 */
export const checkIfUnitTurnSkipShown = (state, unit) => {
  const checkIfProcessedByAction = PROCESSED_BY_ACTION[selectWarPhaseStage(state)];
  const playerId = selectCurrentPlayer(state)?.id;
  return Boolean(checkIfProcessedByAction && playerId && unit.ownerId === playerId
    && selectSkippedUnitIds(state, playerId).includes(unit.id)
    && !checkIfProcessedByAction(state, unit));
};
